
import React, { FunctionComponent, useEffect, useMemo, useRef, useState } from "react";
import { Student } from "../../../../../../../../store/onboarding/types";
import { AlertHistory, AlertHistoryObject, InterventionGroup } from "../../../../../../../../store/onboarding/cases/types";
import Table from "react-bootstrap/Table";
import { getFullName } from "../../../../../../../../utils/NamesUtils";
import { connect, useDispatch } from "react-redux";
import { getAlertHistory } from "../../../../../../../../store/onboarding/cases/actions";
import moment from "moment";
import { ApplicationState } from "../../../../../../../../store";
import LoadingIndicator from "../../../../../../../common/onboarding/LoadingIndicator";

type PropsFromState = {
  alertHistory?: Array<AlertHistory>;
  isLoading?: {
    getAlertHistory: boolean;
  };
  errors?: {
    getAlertHistory: string;
  };
};

type OwnProps = {
  selectedStudents: Student[];
  interventionGroup: InterventionGroup;
  isStudentDetail?: boolean;
  isGroupDetail?: boolean;
  studentId?: number;
  expanded?: boolean;
};

type Props = OwnProps & PropsFromState;

const AlertHistoryTab: FunctionComponent<Props> = (props) => {
  const { 
    interventionGroup, 
    alertHistory,
    studentId,
    expanded
  } = props;

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getAlertHistory(interventionGroup.id, studentId))
  }, []);

  let alertHistoryObject: AlertHistoryObject = useMemo(() => {
    return (alertHistory ?? []).reduce((acc, alert) => {
        const { student_goal_id } = alert;
        const interventionStdGoal = interventionGroup.student_goals.find((sg) => sg.id === student_goal_id);
        const studentName = getFullName(interventionStdGoal?.student) // Ensure student is defined
        const studentIdWithName: any = `${student_goal_id}-${studentName}`;
        if (!acc[studentIdWithName]) {
            acc[studentIdWithName] = [];
        }
        acc[studentIdWithName].push({
            "id": alert.id,
            "alert_reason": alert.alert_reason,
            "created": alert.created,
            "alert_reason_display": alert.alert_reason_display
        } as AlertHistory);
        return acc;
    }, {} as Record<number, AlertHistory[]>);
  }, [alertHistory]);

  const getModalBody = () => {
    if(Object.keys(alertHistoryObject).length) {
      let alertHistoryProgressArray: any[] = [];
      let index:number = 0;
      for (const studentNameWithId in alertHistoryObject) {
        if (Object.prototype.hasOwnProperty.call(alertHistoryObject, studentNameWithId)) {
          const alertHistoryData = alertHistoryObject[studentNameWithId];
          let student: any = studentNameWithId.split("-")[1];

          let alertHistoryRow: any[] = 
            alertHistoryData.reduce((acc, alertHistory) => {
                acc.push(
                    (
                        <tr key={alertHistory.id} className="border-left-0 border-right-0">
                            <td width={expanded ? "50%" : "55%"} style={{borderTop: acc.length < 1 ? '0' : '1', borderRight:'0', borderBottom:'0'}}>
                                {alertHistory.alert_reason_display}
                            </td>
                            <td className="text-left" width={expanded ? "50%" : "45%"} style={{borderTop: acc.length < 1 ? '0' : '1', borderRight:'0', borderBottom:'0'}}>
                                {moment.utc(alertHistory.created).format("MM/DD/YYYY")}
                            </td>
                        </tr>
                    )
                );
                return acc;
            }, [] as JSX.Element[]);
          index++;

          const alertHistoryProgress = 
              <tr key={index}>
                <td width={"33%"} style={{borderRight:'0'}}>
                  {student}
                </td>
                <td width={"66%"} colSpan={2} className="p-0 border-left-0 border-right-0">
                  <Table className="mb-0 secondryGoalTable">
                    {alertHistoryRow}
                  </Table>
                </td>
              </tr>;
         
          alertHistoryProgressArray.push(alertHistoryProgress);
        }
      }
      return alertHistoryProgressArray;
    } else {
      return (
        <>
            <tr>
              <td colSpan={3} className="text-center">No Alert History.</td>
            </tr>
        </>
      )
    }
  }

  const getModalTable = () => {
      return (
        <Table className="goalTable mb-0 secondryGoalTable table-bordered">
          <thead>
            <tr>
              <th style={{ width: "33%" }}>Student</th>
              <th style={{ width: expanded ? "33%" : "37%" }} className="text-left">Alert</th>
              <th style={{ width: "33%" }} className="text-left">Date</th>
            </tr>
          </thead>
          <tbody>
            {props.isLoading?.getAlertHistory
              ? (<tr>
                    <td colSpan={3}><LoadingIndicator /></td>
                </tr>)
              : (
                alertHistoryObject
                  && Object.keys(alertHistoryObject).length
                  ? (
                  getModalBody()
                ) : (
                    <tr>
                    <td colSpan={3} className="text-center p-3">No Alert History</td>
                    </tr>
                )
            )}
          </tbody>
        </Table>
      );
  }
  return (getModalTable());
};

const mapStateToProps = ({ cases }: ApplicationState): PropsFromState => {
  return {
    isLoading: {
        getAlertHistory: cases.isLoading.getAlertHistory,
    },
    errors: {
        getAlertHistory: cases.errors.getAlertHistory!,
    },
    alertHistory: cases.alertHistory,
  };
};

export default connect(mapStateToProps, null)(AlertHistoryTab);
